var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCircleCheck = function SvgCircleCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 96,
    height: 96,
    viewBox: "0 0 96 96"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48,87.5 C26.1847524,87.5 8.5,69.8152476 8.5,48 C8.5,26.1847524 26.1847524,8.5 48,8.5 C69.8152476,8.5 87.5,26.1847524 87.5,48 C87.5,69.8152476 69.8152476,87.5 48,87.5 Z M37.6934003,60.6199738 L26.8170892,49.7436626 L23.3125,53.3690997 L37.6934003,67.75 L68.6304633,36.8129371 L65.0050262,33.1875 L37.6934003,60.6199738 Z",
    fill: "#000000",
    fillRule: "evenodd"
  })));
};
export default SvgCircleCheck;